export class GoogleSDKError extends Error {
    constructor(message?: string) {
        super(message);

        this.name = 'GoogleSDKError';
    }
}
